// Settings manager
// 
// This unit read and write the user UI settings permanently to the browser localStorage per user and site.
export class SettingsManager {
    // settings container
    settings: object;
    // hostname + port if avaiable (80 and 443 port not visible in hostname)
    systemID: string;

    constructor(systemID: string) {
        this.systemID = systemID;

        // is avaiable the local storage feature in browser
        if (!this.storageAvailable('localStorage')) {
            console.log("ERROR: This browser is not support or denied the local storage feature!");
            return;
        }

        // get site specific serialized stored data 
        let data: string = localStorage.getItem('ETDRSettings');

        if (data !== null) {
            // not empty localstorage
            let dataObject: any = JSON.parse(data);

            if (dataObject[this.systemID]) {
                // site conf exists
                this.settings = dataObject;
            }
            else {
                // site conf does not exists, init with empty object
                dataObject[this.systemID] = {};
                this.writeStorage(dataObject);
            }
        }
        else {
            // when empty localstorage, init with empty object
            let settingsObject: object = {};
            settingsObject[this.systemID] = {};
            this.settings = settingsObject;
            this.writeStorage(this.settings);
        }

        this.refreshSettings();
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
    // if avaiable or exists the local or session storage feature in the browser
    private storageAvailable(type) {
        try {
            var storage: any = window[type];
            let testData: string = '__storage_test__';
            storage.setItem(testData, testData);
            storage.removeItem(testData);
            return true;
        }
        catch (e) {
            return e instanceof DOMException && (
                // everything except Firefox
                e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' ||
                // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                // acknowledge QuotaExceededError only if there's something already stored
                storage.length !== 0;
        }
    }

    public refreshSettings() {
        // collect settings fields by attribute
        $('*[data-sm-key]').each((idx, elem) => {
            let $elem = $(elem);

            // resolve default value
            var key = $elem.data("sm-key");
            var defaultValue = $elem.data("sm-default-value");

            // get stored value
            let savedVal = this.getAttribute(key, defaultValue);

            // can't set any value for select elements willy-nilly
            // If the saved value is not a possibility (e.g.: the saved option is not available for the current user or role), try to set the default value blindly
            // (If that does not exists assume the default value was set incorrectly, nothing we can do here)
            if ($elem.is("select") && $elem.children(`option[value='${savedVal}']`).length === 0) {
                $elem.val(defaultValue).change();
            }
            else {
                $elem.val(savedVal).change();
            }

            // save new value
            $elem.change(event => {
                let newVal = $(event.target).val();
                let oldVal = this.getAttribute(key);

                if (newVal !== oldVal) {
                    this.setAttribute(key, newVal);
                }
            });
        });
    }

    // set attribute, then store the modified config
    public setAttribute(attributeName: string, value: any) {
        this.settings[this.systemID][attributeName] = value;
        this.writeStorage(this.settings);
    }

    private writeStorage(data) {
        localStorage.setItem('ETDRSettings', JSON.stringify(data));
    }

    // get the attribute or a default value if not set
    public getAttribute(attributeName: string, defaultValue = null): any {
        if (this.settings[this.systemID].hasOwnProperty(attributeName)) {
            return this.settings[this.systemID][attributeName];
        }
        else {
            return defaultValue;
        }
    }

    // delete the attribute, then store the modified config
    public removeAttribute(attributeName: string) {
        delete this.settings[this.systemID][attributeName];
        this.writeStorage(this.settings);
    }

    // clear all site specific data
    public clearSiteStorage() {
        let data: string = localStorage.getItem('ETDRSettings');
        delete data[this.systemID];
        delete this.settings;
        this.writeStorage(data);
    }
}

export default SettingsManager;